import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-slate-700 via-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="flex flex-col justify-between">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-48 h-48 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/ac092ddd5e8296cd231c029d8c3ac0cf.png" 
                  alt="unuu Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">
              <Link to="/services" className="hover:text-[#00b4a6] transition-colors">Services</Link>
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/services/social-media-management" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Social Media Management
                </Link>
              </li>
              <li>
                <Link to="/services/content-strategy" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Content Strategy
                </Link>
              </li>
              <li>
                <Link to="/services/paid-advertising" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Paid Advertising
                </Link>
              </li>
              <li>
                <Link to="/services/branding" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Branding
                </Link>
              </li>
              <li>
                <Link to="/services/web-design" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Website Design
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Unuu</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/about" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  About Unuu
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="mailto:maria@unuu.co.uk" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  maria@unuu.co.uk
                </a>
              </li>
              <li>
                <a href="tel:+447810306008" className="text-white hover:text-[#00b4a6] transition-colors cursor-pointer">
                  +44 7810 306 008
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-[#00989e] hover:border-[#00989e] transition-all cursor-pointer"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-[#00989e] hover:border-[#00989e] transition-all cursor-pointer"
              >
                <i className="ri-tiktok-line"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-[#00989e] hover:border-[#00989e] transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-[#00989e] hover:border-[#00989e] transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2026 Unuu. All rights reserved.
          </p>
          <div className="flex gap-8 text-sm">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
